import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { RentalSalesResult } from '../models/rental-sales-result.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * HTTP service for the Rentals/Sales Finder. Calls the AirportsAPI `~/rental-sales` endpoint. Category facet
 * filtering (Aircraft Rental / Sales / ...) is applied client-side in {@link SearchPageComponent}; this
 * service performs only the location/state/keyword query.
 */
var RentalSalesService = /** @class */ (function (_super) {
    tslib_1.__extends(RentalSalesService, _super);
    function RentalSalesService(http, errorHandler) {
        var _this = _super.call(this, http, errorHandler) || this;
        _this.endpoint = 'rental-sales';
        return _this;
    }
    RentalSalesService.prototype.parse = function (data) {
        return RentalSalesResult.parse(data);
    };
    RentalSalesService.prototype.getRentalSalesByLatLon = function (latlon, radius) {
        return this.getByLatLon(latlon, radius);
    };
    RentalSalesService.prototype.getRentalSalesByBoundingBox = function (bounds) {
        return this.getByBoundingBox(bounds);
    };
    RentalSalesService.prototype.getRentalSalesByState = function (state) {
        return this.getByState(state);
    };
    RentalSalesService.prototype.getRentalSalesBySearchTerm = function (term) {
        return this.getBySearchTerm(term);
    };
    RentalSalesService.ngInjectableDef = i0.defineInjectable({ factory: function RentalSalesService_Factory() { return new RentalSalesService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: RentalSalesService, providedIn: "root" });
    return RentalSalesService;
}(BusinessFinderService));
export { RentalSalesService };
